"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57663],{

/***/ 309396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ProductCarouselWithHeader; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(990241);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414562);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(842918);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarouselWithHeader = (_a) => {
  var _b = _a, {
    header,
    background,
    dividerColor = "rgba(255, 255, 255, 0.5)",
    style,
    tracking,
    backgroundStyle
  } = _b, productCarouselProps = __objRest(_b, [
    "header",
    "background",
    "dividerColor",
    "style",
    "tracking",
    "backgroundStyle"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const MOBILE_BG_WIDTH = 856, DESKTOP_BG_WIDTH = 1232;
  const backgroundUrl = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .getImageUrlFromGoogleUserContent */ .Nc)(background, {
    width: isMobile ? MOBILE_BG_WIDTH : DESKTOP_BG_WIDTH
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    style: __spreadValues({
      minHeight: header ? "416px" : "372px"
    }, style)
  }, !!tracking ? tracking : {}), backgroundUrl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Background, {
    alt: (header == null ? void 0 : header.title) || "",
    src: backgroundUrl,
    width: "100%",
    height: "100%",
    style: backgroundStyle
  }), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBlockHeader, __spreadProps(__spreadValues({}, header), {
    borderColor: dividerColor
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledProductCarousel, __spreadValues({}, productCarouselProps)));
};
ProductCarouselWithHeader.displayName = "ProductCarouselWithHeader";
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: relative;
`;
const Background = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].img`
  position: absolute;
  top: 0;
`;
const StyledProductCarousel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCarousel */ .G)`
  padding: 12px;
`;
const StyledBlockHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t)`
  border-bottom: 1px solid ${(props) => props.borderColor};
  .title {
    padding: 0 8px;
  }
`;




/***/ }),

/***/ 957663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ DiscoveryBlocks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(982226);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var reflexbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(504545);
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(875663);
/* harmony import */ var helpers_block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(997441);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(775002);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _LazyComponent__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(110413);
/* harmony import */ var _tekface_smart_activation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(560327);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(124177);
/* harmony import */ var _RecentViewedProducts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(751817);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  top: -92px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













const DiscoveryRecommendedProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(10769), __webpack_require__.e(22746)]).then(__webpack_require__.bind(__webpack_require__, 910769)).then((mod)=>mod.DiscoveryRecommendedProducts), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(910769)
            ]
    }
});
const ProductListWithFilter = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(60687), __webpack_require__.e(37070), __webpack_require__.e(97968), __webpack_require__.e(50643), __webpack_require__.e(25552)]).then(__webpack_require__.bind(__webpack_require__, 325552)).then((mod)=>mod.ProductListWithFilter), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(325552)
            ]
    }
});
const TIME_TO_RENDER = 0;
const FeaturedBanners = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(28795), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(90174)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.FeaturedBanners), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const PromoteBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(28795), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(90174)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.PromoteBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const HotDealSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(81633), __webpack_require__.e(27566)]).then(__webpack_require__.bind(__webpack_require__, 927566)).then((mod)=>mod.HotDealSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(927566)
            ]
    }
});
const BestSellingProductsBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 83648).then(__webpack_require__.bind(__webpack_require__, 783648)).then((mod)=>mod.BestSellingProductsBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(783648)
            ]
    }
});
const NavigationBarBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 14956).then(__webpack_require__.bind(__webpack_require__, 414956)).then((mod)=>mod.NavigationBarBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(414956)
            ]
    }
});
const YoutubeBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 68397).then(__webpack_require__.bind(__webpack_require__, 768397)).then((mod)=>mod.YoutubeBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768397)
            ]
    }
});
const LeftRightStickyBannerBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 19931).then(__webpack_require__.bind(__webpack_require__, 937420)).then((mod)=>mod.LeftRightStickyBannerBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(937420)
            ]
    }
});
const ListCategories = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(28795), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(90174)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ListCategories), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const FeaturedBrands = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(28795), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(90174)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.FeaturedBrands), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const FlashSaleBlock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 79855).then(__webpack_require__.bind(__webpack_require__, 579855)).then((mod)=>mod.FlashSaleBlock), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(579855)
            ]
    }
});
const BlockAnchor = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());
const DiscoveryBlocks = (param)=>{
    let { blocks , customRenderer , filterPrice =undefined , ssrMapProducts , filters , inlineBanners , pageTypeEnum  } = param;
    const categoryProductBlockRendered = [];
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { query  } = router;
    const mainSkuList = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MAIN_SKU_LIST */ .kH.MAIN_SKU_LIST, blocks);
    const leftStickyBanner = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.LEFT_STICKY_BANNER */ .kH.LEFT_STICKY_BANNER, blocks);
    const rightStickyBanner = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.RIGHT_STICKY_BANNER */ .kH.RIGHT_STICKY_BANNER, blocks);
    const youtubeBlock = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.YOUTUBE */ .kH.YOUTUBE, blocks);
    const navigationBarBlock = (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.NAVIGATION_BAR */ .kH.NAVIGATION_BAR, blocks);
    const isDefaultBlock = blocks.length === 2 && mainSkuList;
    if (isDefaultBlock) {
        const fetchParams = _objectSpreadProps(_objectSpread({}, mainSkuList.content.fetchParams), {
            blockId: mainSkuList.id
        });
        const filterParams = _objectSpreadProps(_objectSpread({}, fetchParams.filter, fetchParams.sorting), {
            blockId: mainSkuList.id
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductListWithFilter, {
            serverProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[mainSkuList.id],
            filterPrice: filterPrice,
            serverFilters: filters,
            customerParams: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_8__.cleanObject)(_objectSpread({}, filterParams, query))
        });
    }
    const firstCountdownBlockIndex = blocks.findIndex((block)=>block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            navigationBarBlock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavigationBarBlock, {
                block: navigationBarBlock,
                blockList: blocks
            }),
            youtubeBlock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                        id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(youtubeBlock)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeBlock, {
                        block: youtubeBlock
                    })
                ]
            }),
            (leftStickyBanner || rightStickyBanner) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftRightStickyBannerBlock, {
                leftBlock: leftStickyBanner,
                rightBlock: rightStickyBanner,
                stickyTop: navigationBarBlock ? 112 : 72
            }),
            firstCountdownBlockIndex === -1 && pageTypeEnum === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .PageTypeEnum.HOME */ .DZ.HOME ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_10__/* .BannerInlinePlaceholder */ .Q, {
                    banners: inlineBanners,
                    className: _constants__WEBPACK_IMPORTED_MODULE_11__/* .INLINE_BANNER_CLASSNAME.INLINE_HOME_BODY */ .h.INLINE_HOME_BODY
                })
            }) : null,
            blocks.map((block, index, list)=>{
                var ref, ref1, ref2;
                const showBannerHorizontal = block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockItemType.BANNER */ .Nc.BANNER && block.type.startsWith("HORIZONTAL") && block.type !== _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.HORIZONTAL_4_BANNER */ .kH.HORIZONTAL_4_BANNER && (block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref.length);
                const showCategoryProductBlock = block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER && index > 1 && !categoryProductBlockRendered.includes(list[index - 1].id) && list[index - 1].type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER;
                const showTopBrands = block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockItemType.MENU */ .Nc.MENU && block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.HORIZONTAL_HIGHLIGHTED_BANNER */ .kH.HORIZONTAL_HIGHLIGHTED_BANNER && (block === null || block === void 0 ? void 0 : (ref1 = block.cookedData) === null || ref1 === void 0 ? void 0 : ref1.length);
                const showCustomCategories = block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.PROMOTE_CATEGORY_MENU */ .kH.PROMOTE_CATEGORY_MENU && (block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : ref2.length);
                const ConditionalLazyComponent = block.ssr ? react__WEBPACK_IMPORTED_MODULE_2__.Fragment : _LazyComponent__WEBPACK_IMPORTED_MODULE_12__/* .LazyComponent */ .c;
                if (showCustomCategories) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                        marginBottom: "s24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListCategories, {
                                categories: block.cookedData.map((category)=>{
                                    return {
                                        title: category.campaignName,
                                        image: {
                                            src: category.image
                                        },
                                        link: {
                                            href: category.targetPath
                                        }
                                    };
                                }),
                                header: {
                                    title: block.label
                                }
                            })
                        ]
                    }, index);
                }
                if (showTopBrands) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                    timeToRender: TIME_TO_RENDER,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                        marginBottom: "s24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedBrands, {
                                header: {
                                    title: block.label
                                },
                                brands: block.cookedData.map((bl)=>({
                                        name: bl.campaignName,
                                        description: bl.description,
                                        image: {
                                            src: bl.image
                                        },
                                        link: {
                                            href: bl.targetPath
                                        }
                                    }))
                            })
                        ]
                    })
                }, index);
                if (showCategoryProductBlock) {
                    categoryProductBlockRendered.push(block.id);
                    categoryProductBlockRendered.push(list[index - 1].id);
                    const categoryBlock1 = list[index - 1].cookedData;
                    const categoryBlock2 = block.cookedData;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        timeToRender: TIME_TO_RENDER,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                    id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
                                    marginBottom: 24,
                                    flexWrap: "wrap",
                                    mx: -2,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                            width: [
                                                1,
                                                1 / 2
                                            ],
                                            px: 2,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PromoteBlock, _objectSpread({}, categoryBlock1))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reflexbox__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                            width: [
                                                1,
                                                1 / 2
                                            ],
                                            px: 2,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PromoteBlock, _objectSpread({}, categoryBlock2))
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index);
                }
                // block.cookedData is the result of transformBanner function
                if (showBannerHorizontal) {
                    const banners = block.cookedData.map((banner)=>{
                        return {
                            src: banner.image,
                            link: {
                                href: banner.targetPath
                            },
                            name: banner.campaignName
                        };
                    });
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                        marginBottom: "s24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedBanners, {
                                banners: banners,
                                regionName: "horizontalBanner".concat(banners.length)
                            })
                        ]
                    }, index);
                }
                if (customRenderer) {
                    // for other block types
                    // allow an input customRenderer to overwrite
                    // the default input
                    const blockNode = customRenderer(block, index);
                    if (blockNode) return blockNode;
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.COUNT_DOWN_PROMO_SKU */ .kH.COUNT_DOWN_PROMO_SKU || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.FLASH_SALE */ .kH.FLASH_SALE) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlashSaleBlock, {
                                block: block,
                                ssrProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[block.id]
                            })
                        ]
                    }, index);
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.HORIZONTAL_SKU_LIST */ .kH.HORIZONTAL_SKU_LIST || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.BEST_SELLING_PRODUCT */ .kH.BEST_SELLING_PRODUCT) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        timeToRender: TIME_TO_RENDER,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                            marginBottom: "s24",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                    id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BestSellingProductsBlock, {
                                    block: block,
                                    ssrProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[block.id]
                                })
                            ]
                        })
                    }, index);
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU) {
                    var ref3, ref4, ref5;
                    const serverItemId = block === null || block === void 0 ? void 0 : (ref3 = block.cookedData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : ref5.itemId;
                    const ssrProducts = ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts["".concat(block.id, "_").concat(serverItemId)];
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                                marginBottom: "s24",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                        id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HotDealSection, {
                                        block: block,
                                        ssrProducts: ssrProducts
                                    })
                                ]
                            }, index),
                            firstCountdownBlockIndex === index && pageTypeEnum === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .PageTypeEnum.HOME */ .DZ.HOME ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                                style: {
                                    overflow: "hidden"
                                },
                                marginBottom: "s24",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_10__/* .BannerInlinePlaceholder */ .Q, {
                                    banners: inlineBanners,
                                    className: _constants__WEBPACK_IMPORTED_MODULE_11__/* .INLINE_BANNER_CLASSNAME.INLINE_HOME_BODY */ .h.INLINE_HOME_BODY
                                })
                            }, "BannerInlinePlaceholder") : null
                        ]
                    });
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.MAIN_SKU_LIST */ .kH.MAIN_SKU_LIST || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.PROMOTE_SELLER */ .kH.PROMOTE_SELLER) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        timeToRender: TIME_TO_RENDER,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W, {
                            marginBottom: "s24",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockAnchor, {
                                    id: (0,helpers_block__WEBPACK_IMPORTED_MODULE_6__/* .getBlockDomId */ .Zj)(block)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiscoveryRecommendedProducts, {
                                    title: block.label,
                                    paramsObject: _objectSpreadProps(_objectSpread({}, block.cookedData.paramsObject), {
                                        blockId: block.id
                                    }),
                                    actionLink: block.viewMoreUrl ? {
                                        href: block.viewMoreUrl
                                    } : undefined,
                                    ssrProducts: ssrMapProducts === null || ssrMapProducts === void 0 ? void 0 : ssrMapProducts[block.id]
                                })
                            ]
                        }, index)
                    }, index);
                }
                if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_7__/* .BlockType.RECENT_PRODUCT */ .kH.RECENT_PRODUCT) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLazyComponent, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RecentViewedProducts__WEBPACK_IMPORTED_MODULE_13__/* .RecentViewedProducts */ .Z, {})
                    }, index);
                }
            })
        ]
    });
};


/***/ }),

/***/ 751817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RecentViewedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(743126);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(309396);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(679376);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88837);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(185081);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const RecentViewedProducts = (props)=>{
    const { render , excludedSkus  } = props, rest = _objectWithoutProperties(props, [
        "render",
        "excludedSkus"
    ]);
    const recentViewedProductsSkus = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)() ? (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJsonStringSafely */ .O)(localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__/* .RECENTLY_VIEWED_PRODUCTS_KEY */ ._V) || "[]", []) || [] : [];
    const { result , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSearch */ .Rx)(recentViewedProductsSkus.length ? {
        filter: {
            skus: recentViewedProductsSkus,
            excludedSkus: excludedSkus
        },
        pageSize: 50,
        page: 1
    } : {});
    const products = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const newProducts = [];
        recentViewedProductsSkus.forEach((sku)=>{
            const productFoundBySku = result.products.find((item)=>item.sku === sku);
            if (productFoundBySku) {
                newProducts.push(productFoundBySku);
            }
        });
        return newProducts;
    }, [
        result.products
    ]);
    if (!products.length && !isLoading) return null;
    return !!render ? render(products) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W, _objectSpreadProps(_objectSpread({}, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .ProductCarouselWithHeader */ .B, {
                header: {
                    title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sản phẩm vừa xem")
                },
                products: products,
                regionName: "viewedItem"
            })
        })
    }));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .CommonStyles */ .F, "\n    background: white;\n    border-radius: 0.5rem;\n    margin-bottom: 1.5rem;\n    .product-card{\n      border: 1px solid ".concat(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .themeColor.divider */ .E.divider, ";\n      border-radius: 4px;\n    }\n  "));


/***/ })

}]);